/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgCheckboxRounded = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM11.681 6.64666C12.0871 6.24052 12.0871 5.58202 11.681 5.17588C11.2748 4.76973 10.6163 4.76973 10.2102 5.17588L6.70294 8.68313L5.45844 7.43862C5.05229 7.03248 4.3938 7.03248 3.98765 7.43862C3.58151 7.84477 3.58151 8.50326 3.98765 8.9094L5.96755 10.8893C6.3737 11.2954 7.03219 11.2954 7.43833 10.8893L11.681 6.64666Z'
    />
  </svg>
)
export default SvgCheckboxRounded
